const puffandgo = {
    id: 'puffandgo',
    publicSiteName: 'Puff And Go',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#437a38',
            secondary: '#0e0e0e',
            color1: '#71c461',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/puffandgo/favicon.ico',
        logo: '/puffandgo/logo.png',
    },
    features: {
        rewards: false,
        subscriptions: false,
    },
}

export default puffandgo